var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change_cover"},[_vm._v("\n  change_cover\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }